<template>
	<div class="match-center">
		<div class="match-center__header">
			<SectionTitle
				:title="$I18n.trans('arena.match_center.title')"
				type="main"
			/>
		</div>
		<MatchDaysEuf
			ref="matchDays"
			:teams="teams"
			:events="events"
			:league-id="leagueId"
			:is-loading="isLoadingEvents"
		/>
	</div>
</template>

<script>
import SectionTitle from '@js/components/SectionTitle';
import MatchDaysEuf from './MatchDaysEuf';
import { httpClient } from '@shared/js/api/httpClient';
import { EventFilter } from '@shared/enums/EventFilter';

export default {
	name:       'MatchCenterEuf',
	components: { MatchDaysEuf, SectionTitle },
	props:      {
		teams: {
			type:     Array,
			required: true,
		},
		leagueId: {
			type:     Number,
			required: true,
		},
	},
	data() {
		return {
			events:          null,
			isLoadingEvents: false,
		};
	},
	mounted() {
		this.loadEvents();
	},
	methods: {
		async loadEvents() {
			try {
				this.isLoadingEvents = true;

				// search Params
				const searchParams = new URLSearchParams();

				const filters = {
					[EventFilter.LEAGUE]:          this.leagueId,
					[EventFilter.EVENT]:           null,
					[EventFilter.ARENA_AVAILABLE]: null,
				};

				searchParams.append('useContextFilter', false);
				searchParams.append('filters', JSON.stringify(filters));
				searchParams.append('sortOrder', JSON.stringify({
					views: 'asc',
				}));

				searchParams.append('relations', 'participants,participants.participatable,scores,scores.period,sport');

				const response = await httpClient.getEventsCached(Object.fromEntries(searchParams));
				this.events = response.data;
			} catch (error) {
				// shows empty events
			} finally {
				this.isLoadingEvents = false;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@sass/variables';

.match-center {
	padding-top: $sp6;
}

.match-center__header {
	display: flex;
	justify-content: space-between;
	align-items: baseline;
	margin-bottom: #{-$sp4};
}

</style>
